import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API, withCredentials: true });

export const CATEGORY_META = {
  rims: {
    label: "Rims",
    tagline: "Forged stance. Zero compromise.",
    image:
      "https://images.unsplash.com/photo-1761846788408-4a5186f4db87?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
  },
  tires: {
    label: "Tires",
    tagline: "Grip that refuses to quit.",
    image:
      "https://images.unsplash.com/photo-1760136645109-ffce7e5db89e?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
  },
  suspension: {
    label: "Suspension",
    tagline: "Lift it. Level it. Own it.",
    image:
      "https://images.pexels.com/photos/11532598/pexels-photo-11532598.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=900&w=1400",
  },
};

export const IMAGES = {
  hero: "https://images.unsplash.com/photo-1601252300554-4ad551483bd2?crop=entropy&cs=srgb&fm=jpg&q=85&w=2000",
  truck2:
    "https://images.unsplash.com/photo-1692807381316-e51140a7a00f?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
  truck3:
    "https://images.unsplash.com/photo-1581012702928-017890500a6b?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
  desert:
    "https://images.unsplash.com/photo-1676390812819-0ecd8b09d41a?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
};

export const money = (n) =>
  `$${Number(n).toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
